module.exports = __webpack_public_path__ + "img/prevPage2.a1782937.png";